import React from "react";
import {
  Button,
  Container,
  Checkbox,
  FormControl,
  Grid,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Box,
  Modal,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MyModal = ({ open, onClose, userData }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px",
    // display: "flex", // Add flexbox display
    // flexDirection: "column", // Set direction to column
    // alignItems: "center", // Center items horizontally
    // justifyContent: "center", // Center items vertically
  };
  const closeButtonStyle = {
    position: "absolute",
    top: 8,
    right: 8,
    color: "grey.500",
  };

  const renderContent = () => {
    switch (userData) {
      case "background-color":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">
              Content for Background Color
            </Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/BackgroundColor.jpg"}
              alt="Secondary Font"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "primary-color":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for primary-color</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/PrimaryColor1.jpg"}
              alt="PrimaryColor.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "secondary-color":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for secondary-color</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/PrimaryColor.jpg"}
              alt="Secondary Font"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "light-secondary-color":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">
              Content for light-secondary-color
            </Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/lightSecondarColor.jpg"}
              alt="Secondary Font"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "secondary-dark-color":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">
              Content for secondary-dark-color
            </Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/SecondaryDarkColor.jpg"}
              alt="SecondaryDarkColor.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "background-light":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">
              Content for background-light
            </Typography>
            <br />
          </div>
        );
      case "border-color":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body1">Content for border-color</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/BorderColor.jpg"}
              alt="BorderColor.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "feature-box-bg":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body1">Content for feature-box-bg</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/FeatureBlockBg.jpg"}
              alt="TableHeader.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "faq-border":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for faq-border</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/CL.jpg"}
              alt="TableHeader.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "font-primary":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for font-primary</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/FontPrimary.jpg"}
              alt="FontPrimary.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "font-secondary":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for font-secondary</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/FontSecondary.jpg"}
              alt="FontPrimary.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "dark-text":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for dark-text</Typography>
          </div>
        );
      case "input-bg":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content for input-bg</Typography>
            <img
              src={process.env.PUBLIC_URL + "/static/Input_Bg.jpg"}
              alt="FontPrimary.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "contestBlock-bg":
        return (
          <div>
            <Typography variant="h6">Summary : </Typography>
            <Typography variant="body2">Content forcontestBlock-bg</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/contestBlogBg.jpg"}
              alt="TableHeader.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "table-header":
        return (
          <div>
            <Typography variant="body1">Summary : </Typography>
            <Typography variant="body2">Content for table-header</Typography>
            <img
              src={process.env.PUBLIC_URL + "/static/TableHeader.jpg"}
              alt="TableHeader.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "circle-color":
        return (
          <div>
            <Typography variant="body1">Summary : </Typography>
            <Typography variant="body1">Content for circle-color</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/CL.jpg"}
              alt="TableHeader.jpg"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      case "progress-color":
        return (
          <div>
            <Typography variant="body1">Summary : </Typography>
            <Typography variant="body1">Content for progress-color</Typography>
            <br />
            <img
              src={process.env.PUBLIC_URL + "/static/ProgressColor.jpg"}
              alt="ProgressColor"
              style={{ borderRadius: "10px" }}
            />
          </div>
        );
      // Add more cases as needed
      default:
        return <Typography variant="body1">Default Content</Typography>;
    }
  };
  return (
    <div>
      {" "}
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="lg"
      >
        <Box sx={style}>
          <IconButton onClick={onClose} style={closeButtonStyle}>
            <CloseIcon />
          </IconButton>
          {renderContent()}
        </Box>
      </Modal>
    </div>
  );
};

export default MyModal;
